module.exports = "/* .hidden {\r\n    display: none;\r\n} */"